const groups = [
    { key: 'compute', label: 'Compute' },
    { key: 'network', label: 'Network' },
    { key: 'volume', label: 'Volume' }
]

const labels = {
    instances: 'Instances',
    cores: 'vCPUs',
    ram_mb: 'RAM (MiB)',
    floating_ips: 'Floating IPs',
    security_groups: 'Security groups',
    server_groups: 'Server groups',
    network: 'Networks',
    subnet: 'Subnets',
    subnetpool: 'Subnet pools',
    port: 'Ports',
    router: 'Routers',
    floatingip: 'Floating IPs',
    rbac_policy: 'RBAC policies',
    security_group: 'Security groups',
    security_group_rule: 'Security group rules',
    volumes: 'Volumes',
    volume_gigabytes: 'Volume storage (GiB)',
    snapshots: 'Snapshots',
    backups: 'Backups',
    backup_gigabytes: 'Backup storage (GiB)'
}

function quotaResource(key, value) {
    const used = value?.used
    const limit = value?.limit
    const validUsage = Number.isFinite(used) && used >= 0
    const unlimited = limit === -1
    const available = validUsage && Number.isFinite(limit) && (limit >= 0 || unlimited)
    const percent = available && !unlimited ? (limit === 0 ? (used > 0 ? 100 : 0) : Math.min(100, (used / limit) * 100)) : 0
    const usedText = validUsage ? used.toLocaleString() : 'Unknown'
    const limitText = unlimited ? 'Unlimited' : Number.isFinite(limit) && limit >= 0 ? limit.toLocaleString() : 'Unknown'

    return {
        key,
        label: labels[key] || key.replace(/_/g, ' '),
        available,
        unlimited: available && unlimited,
        percent,
        color: percent >= 90 ? 'error' : percent >= 75 ? 'warning' : 'primary',
        text: `${usedText} / ${limitText} used`
    }
}

export function quotaGroups(cluster) {
    return groups.map(group => {
        const data = cluster.provider_quota?.[group.key]
        const resources = data && !data.error ? Object.entries(data).filter(([key]) => key !== 'error') : []
        return {
            ...group,
            unavailable: !resources.length,
            resources: resources.map(([key, value]) => quotaResource(key, value))
        }
    })
}

export function quotaSummary(cluster) {
    return [
        ['compute', 'cores', 'vCPUs'],
        ['compute', 'ram_mb', 'RAM (MiB)'],
        ['volume', 'volume_gigabytes', 'Storage (GiB)']
    ].map(([group, key, label]) => {
        const data = cluster.provider_quota?.[group]
        return { ...quotaResource(key, data?.error ? undefined : data?.[key]), label }
    })
}

export async function fetchPoolQuotas(axios, pools, setState, shouldFetch = () => true) {
    // Limit concurrent requests when the pool list is large.
    const pending = pools.filter(pool => pool.is_rp_manager).slice()
    await Promise.all(
        Array.from({ length: Math.min(4, pending.length) }, async () => {
            while (pending.length) {
                const pool = pending.shift()
                if (!shouldFetch(pool)) continue
                setState(pool.rpid, { loading: true, error: false, clusters: [] })
                try {
                    const { data } = await axios.get(`/resource_pools/${pool.rpid}/tenant_cluster`)
                    const clusters = Array.isArray(data) ? data : data?.tcid ? [data] : []
                    setState(pool.rpid, { loading: false, error: false, clusters })
                } catch (error) {
                    setState(pool.rpid, { loading: false, error: true, clusters: [] })
                }
            }
        })
    )
}
